module.exports = __webpack_public_path__ + "img/airport.8909100b.png";